import { PayloadAction } from '@reduxjs/toolkit'

import { LoadingStatusEnum } from '../../../../store/types'
import { BlockedIp } from '../api/types'

import { StateType } from './initialState'

export const GetBlockedIpsReducer = {
  pending: (state: StateType) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state: StateType, action: PayloadAction<BlockedIp[]>) => ({
    ...state,
    list: action.payload,
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state: StateType) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
}

export const UpdateBlockedIpReducer = {
  pending: (state: StateType) => ({
    ...state,
    loading: LoadingStatusEnum.Pending,
  }),
  fulfilled: (state: StateType, action: PayloadAction<BlockedIp>) => ({
    ...state,
    list: state.list.map((item) => (item.id === action.payload.id ? action.payload : item)),
    loading: LoadingStatusEnum.Succeeded,
  }),
  rejected: (state: StateType) => ({
    ...state,
    loading: LoadingStatusEnum.Failed,
  }),
}
